// Desktop notifications and permission requests are separate from push subscriptions.
export const isNotificationsSupported = () => {
  return (
    typeof window !== 'undefined' &&
    window.isSecureContext === true &&
    typeof window.Notification === 'function' &&
    typeof window.Notification.requestPermission === 'function'
  );
};

// Call from an explicit user action; unsupported/blocked requests must not abort page setup.
export const requestBrowserNotificationPermission = async () => {
  if (!isNotificationsSupported()) {
    return 'unsupported';
  }

  const notification = window.Notification;
  if (notification.permission === 'granted' || notification.permission === 'denied') {
    return notification.permission;
  }

  try {
    return await notification.requestPermission();
  } catch (error) {
    return notification.permission || 'default';
  }
};
